var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{attrs:{"type":"button","disabled":_vm.totalObjetos > 0 || !_vm.active},on:{"click":_vm.onClick}},[_c('i',{staticClass:"fas fa-trash-alt"})])
}
var staticRenderFns = []

export { render, staticRenderFns }